import React from "react";

const LineIcon = ({
    width = "36",
    height = "36",
    viewBox = "0 0 36 36",
    fill = "none",
    xmlns = "http://www.w3.org/2000/svg",
    pathFill = "white",
    ...props
}) => (
    <svg
        width={width}
        height={height}
        viewBox={viewBox}
        fill={fill}
        xmlns={xmlns}
        {...props}
    >
        <path
            d="M10.2499 19.5001C9.89587 19.5001 9.599 19.3799 9.35925 19.1394C9.11975 18.8991 9 18.6013 9 18.2458C9 17.8903 9.11975 17.5938 9.35925 17.3563C9.599 17.1187 9.89587 17 10.2499 17H25.7749C26.1291 17 26.426 17.1202 26.6655 17.3607C26.9052 17.6012 27.0251 17.8991 27.0251 18.2544C27.0251 18.6099 26.9052 18.9064 26.6655 19.1439C26.426 19.3814 26.1291 19.5001 25.7749 19.5001H10.2499Z"
            fill={pathFill}
        />
    </svg>
);

export { LineIcon };
